// Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

// Auth
export const SIGNIN = '/';

export const EXPIRATIONTOKEN = '/expirationtoken';

export const PAGENOTFOUND = '/*';

// Home
export const HOME = '/home';

// Users
export const USERS = '/users';
export const USERLIST = '/users/list';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

export const UPDATE_PASSWORD = `${USERS}/update/password`;

// Chat
export const CHATVIDEO = '/videocall';
export const CHAT = '/chat';
export const CHAT_WEB = '/chat-web';
export const CHAT_BOT = '/chat-bot';
export const PQRWEB = '/pqr-web';
export const PQRWEB_SEARCH = '/pqr-web/search';
export const PQRWEB_CREATE = '/pqr-web/create';
export const PQRWEB_SURVEY = '/pqr-web/survey';
export const PQRWEB_SURVEY_RESPONSE = '/pqr-web/survey/response';

// Update channels SMS Form
export const CHANNELSSMSFORM = '/channels-web';
export const CHANNELSMSFORMTHANKYOU = '/channels-web/thank-you';

// Export
export const EXPORT = '/export';

// Modules
export const MODULES = '/modules';
export const ACCOUNTS = `${MODULES}/accounts`;
export const ACCOUNTS_DETAIL = `${ACCOUNTS}/detail`;
export const ACCOUNTS_NEW = `${ACCOUNTS}/new`;
export const ACCOUNTS_EDIT = `${ACCOUNTS}/edit`;
export const PQR = `${MODULES}/pqr`;
export const PQR_DETAIL = `${PQR}/detail`;
export const PQR_HISTORY = `${PQR}/history`;
export const PQR_NEW = `${PQR}/new`;
export const PQR_EDIT = `${PQR}/edit`;
export const PQR_SURVEY_DETAIL = `${PQR}/survey-detail`;

export const SARLAFT = `${MODULES}/sarlaft`;
export const SARLAFT_DETAIL = `${SARLAFT}/detail`;
export const SARLAFT_EDIT = `${SARLAFT}/edit`;
export const GENERAL = `${MODULES}/accounts`;
export const SEARCH_CASE = `${MODULES}/pqr`;
export const CASES_GENERAL_INFORMATION = `${MODULES}/general-case-info`;
export const CASES_GENERAL_INFORMATION_DETAIL = `${CASES_GENERAL_INFORMATION}/detail`;
export const CASES_GENERAL_INFORMATION_EDIT = `${CASES_GENERAL_INFORMATION}/edit`;
export const CASES_GENERAL = `${MODULES}/cases-general`;
// export const CASES_GENERAL_CREATE = `${MODULES}/cases-general/create`;
export const CASES_GENERAL_DETAIL = `${CASES_GENERAL}/detail`;
export const CASES_GENERAL_EDIT = `${CASES_GENERAL}/edit`;

export const QUOTATION = `${MODULES}/quotation`;
export const QUOTATION_DETAIL = `${QUOTATION}/detail`;
export const QUOTATION_EDIT = `${QUOTATION}/edit`;
export const QUOTATION_NEW = `${QUOTATION}/new`;

export const EMAIL_SENDING = `${MODULES}/email-sending`;

export const SWITCH = `${MODULES}/switch`;
export const SWITCH_DETAIL = `${SWITCH}/detail`;
export const SWITCH_EDIT = `${SWITCH}/edit`;
export const SWITCH_NEW = `${SWITCH}/new`;

// PQR Management
export const PQR_MANAGEMENT = '/pqr-management';
export const LEGAL_PROCEEDINGS = `${PQR_MANAGEMENT}/legal-proceedings`;
export const LEGAL_PROCEEDINGS_NEW = `${LEGAL_PROCEEDINGS}/new`;
export const LEGAL_PROCEEDINGS_EDIT = `${LEGAL_PROCEEDINGS}edit`;
export const LEGAL_PROCEEDINGS_DETAIL = `${LEGAL_PROCEEDINGS}detail`;

export const ALERTS = `${PQR_MANAGEMENT}/alerts`;
export const ALERTS_NEW = `${ALERTS}/new`;
export const ALERTS_EDIT = `${ALERTS}/edit`;
export const ALERTS_DETAIL = `${ALERTS}/detail`;

export const SAMPLES = `${PQR_MANAGEMENT}/pqr-samples`;
export const SAMPLES_EDIT = `${SAMPLES}/edit`;
export const SAMPLES_DETAIL = `${SAMPLES}/detail`;

// Orbit
export const ORBIT = '/orbit';
export const ORBIT_HISTORY = `${ORBIT}/history`;
export const ORBIT_DETAIL = `${ORBIT}/detail`;

// Typifications
export const TYPIFICATIONS = '/typifications';
export const FINAL_CAUSALITY = `${TYPIFICATIONS}/final-causality`;
export const FINAL_CAUSALITY_NEW = `${FINAL_CAUSALITY}/new`;
export const FINAL_CAUSALITY_EDIT = `${FINAL_CAUSALITY}/edit`;
export const FINAL_CAUSALITY_DETAIL = `${FINAL_CAUSALITY}/detail`;

export const INITIAL_CAUSALITY = `${TYPIFICATIONS}/initial_causality`;
export const INITIAL_CAUSALITY_DETAIL = `${INITIAL_CAUSALITY}/detail`;
export const INITIAL_CAUSALITY_NEW = `${INITIAL_CAUSALITY}/new`;
export const INITIAL_CAUSALITY_EDIT = `${INITIAL_CAUSALITY}/edit`;

//Redirect PQR
export const REDIRECTMODULE = '/redirect';

export const REDIRECTLIST = `${REDIRECTMODULE}/person`;
export const REDIRECTNEW = `${REDIRECTMODULE}/person/new`;
export const REDIRECTEDIT = `${REDIRECTMODULE}/person/edit`;
export const REDIRECT_DETAIL = `${REDIRECTMODULE}/person/detail`;

export const REDIRECT_AREA = `${REDIRECTMODULE}/area`;
export const REDIRECT_AREA_NEW = `${REDIRECTMODULE}/area/new`;
export const REDIRECT_AREA_EDIT = `${REDIRECTMODULE}/area/edit`;
export const REDIRECT_AREA_DETAIL = `${REDIRECTMODULE}/area/detail`;

// System Config
export const SYSTEMCONFIG = '/config';

export const MOTIVE = `${SYSTEMCONFIG}/motive`;
export const MOTIVE_NEW = `${SYSTEMCONFIG}/motive/new`;
export const MOTIVE_EDIT = `${SYSTEMCONFIG}/motive/edit`;
export const MOTIVE_DETAIL = `${SYSTEMCONFIG}/motive/detail`;

export const SUBMOTIVE1 = `${SYSTEMCONFIG}/submotive1`;
export const SUBMOTIVE1_NEW = `${SYSTEMCONFIG}/submotive1/new`;
export const SUBMOTIVE1_EDIT = `${SYSTEMCONFIG}/submotive1/edit`;
export const SUBMOTIVE1_DETAIL = `${SYSTEMCONFIG}/submotive1/detail`;

export const SUBMOTIVE2 = `${SYSTEMCONFIG}/submotive2`;
export const SUBMOTIVE2_NEW = `${SYSTEMCONFIG}/submotive2/new`;
export const SUBMOTIVE2_EDIT = `${SYSTEMCONFIG}/submotive2/edit`;
export const SUBMOTIVE2_DETAIL = `${SYSTEMCONFIG}/submotive2/detail`;

export const SUBMOTIVE3 = `${SYSTEMCONFIG}/submotive3`;
export const SUBMOTIVE3_NEW = `${SYSTEMCONFIG}/submotive3/new`;
export const SUBMOTIVE3_EDIT = `${SYSTEMCONFIG}/submotive3/edit`;
export const SUBMOTIVE3_DETAIL = `${SYSTEMCONFIG}/submotive3/detail`;

export const SUBMOTIVE4 = `${SYSTEMCONFIG}/submotive4`;
export const SUBMOTIVE4_NEW = `${SYSTEMCONFIG}/submotive4/new`;
export const SUBMOTIVE4_EDIT = `${SYSTEMCONFIG}/submotive4/edit`;
export const SUBMOTIVE4_DETAIL = `${SYSTEMCONFIG}/submotive4/detail`;

export const PROCEDURE = `${SYSTEMCONFIG}/procedure`;
export const PROCEDURE_NEW = `${SYSTEMCONFIG}/procedure/new`;
export const PROCEDURE_EDIT = `${SYSTEMCONFIG}/procedure/edit`;
export const PROCEDURE_DETAIL = `${SYSTEMCONFIG}/procedure/detail`;

export const PQR_TYPE = `${SYSTEMCONFIG}/type_pqr`;
export const PQR_TYPE_NEW = `${SYSTEMCONFIG}/type_pqr/new`;
export const PQR_TYPE_EDIT = `${SYSTEMCONFIG}/type_pqr/edit`;
export const PQR_TYPE_DETAIL = `${SYSTEMCONFIG}/type_pqr/detail`;

export const SUBTYPE_DP = `${SYSTEMCONFIG}/subtype-dp`;
export const SUBTYPE_DP_NEW = `${SYSTEMCONFIG}/subtype-dp/new`;
export const SUBTYPE_DP_EDIT = `${SYSTEMCONFIG}/subtype-dp/edit`;
export const SUBTYPE_DP_DETAIL = `${SYSTEMCONFIG}/subtype-dp/detail`;

export const PQR_RECEPTION_CHANNEL = `${SYSTEMCONFIG}/reception-channel`;
export const PQR_RECEPTION_CHANNEL_NEW = `${SYSTEMCONFIG}/reception-channel/new`;
export const PQR_RECEPTION_CHANNEL_EDIT = `${SYSTEMCONFIG}/reception-channel/edit`;
export const PQR_RECEPTION_CHANNEL_DETAIL = `${SYSTEMCONFIG}/reception-channel/detail`;

export const PRODUCT = `${SYSTEMCONFIG}/product`;
export const PRODUCT_NEW = `${SYSTEMCONFIG}/product/new`;
export const PRODUCT_EDIT = `${SYSTEMCONFIG}/product/edit`;
export const PRODUCT_DETAIL = `${SYSTEMCONFIG}/product/detail`;

export const PQR_RECEIVED_THROUGH = `${SYSTEMCONFIG}/received-through`;
export const PQR_RECEIVED_THROUGH_NEW = `${SYSTEMCONFIG}/received-through/new`;
export const PQR_RECEIVED_THROUGH_EDIT = `${SYSTEMCONFIG}/received-through/edit`;
export const PQR_RECEIVED_THROUGH_DETAIL = `${SYSTEMCONFIG}/received-through/detail`;

export const FRAUD_MODE = `${SYSTEMCONFIG}/fraud-mode`;
export const FRAUD_MODE_NEW = `${SYSTEMCONFIG}/fraud-mode/new`;
export const FRAUD_MODE_EDIT = `${SYSTEMCONFIG}/fraud-mode/edit`;
export const FRAUD_MODE_DETAIL = `${SYSTEMCONFIG}/fraud-mode/detail`;

export const FRAUD_TYPE = `${SYSTEMCONFIG}/fraud-type`;
export const FRAUD_TYPE_NEW = `${SYSTEMCONFIG}/fraud-type/new`;
export const FRAUD_TYPE_EDIT = `${SYSTEMCONFIG}/fraud-type/edit`;
export const FRAUD_TYPE_DETAIL = `${SYSTEMCONFIG}/fraud-type/detail`;

export const PQR_TIMES = `${SYSTEMCONFIG}/status_pqr`;
export const PQR_TIMES_NEW = `${SYSTEMCONFIG}/status_pqr/new`;
export const PQR_TIMES_EDIT = `${SYSTEMCONFIG}/status_pqr/edit`;
export const PQR_TIMES_DETAIL = `${SYSTEMCONFIG}/status_pqr/detail`;

export const FUNCTIONARIES_SWITCHBOARD = `${SYSTEMCONFIG}/functionaries-switchboard`;
export const FUNCTIONARIES_SWITCHBOARD_NEW = `${FUNCTIONARIES_SWITCHBOARD}/new`;
export const FUNCTIONARIES_SWITCHBOARD_EDIT = `${FUNCTIONARIES_SWITCHBOARD}/edit`;
export const FUNCTIONARIES_SWITCHBOARD_DETAIL = `${FUNCTIONARIES_SWITCHBOARD}/detail`;

export const COMPLIANCE_TERMS = `${SYSTEMCONFIG}/compliance-terms`;
export const COMPLIANCE_TERMS_NEW = `${COMPLIANCE_TERMS}/new`;
export const COMPLIANCE_TERMS_EDIT = `${COMPLIANCE_TERMS}/edit`;
export const COMPLIANCE_TERMS_DETAIL = `${COMPLIANCE_TERMS}/detail`;

// Surveys
export const SURVEYS = `${MODULES}/surveys`;
export const SURVEYS_LIST = `${SURVEYS}/list`;
export const SURVEYS_NEW = `${SURVEYS}/new`;
export const SURVEYS_EDIT = `${SURVEYS}/edit`;
export const SURVEYS_DETAIL = `${SURVEYS}/detail`;
export const SURVEYS_RENDER = `/survey`; // Ruta pública para renderizar encuestas
export const SURVEYS_RESPONSES = `${SURVEYS}/responses`;
export const SURVEYS_RESPONSES_DETAIL = `${SURVEYS_RESPONSES}/detail/:id`;
